<template>
  <div
    class="_text _designer-element"
    :class="isActive ? 'active' : ''"
    v-click-outside="stopEditing"
    :id="data.id"
    :style="getStyle"
    @dblclick="startEditing"
    @click="setActiveItem"
  >
    <span :contenteditable="data.editable" :style="{'fontFamily' : data.fontFamily+'!important'}" @keyup="contentChanged">{{
      data.content
    }}</span>
  </div>
</template>

<script>
import ClickOutside from "vue-click-outside";
import $ from "jquery";
import "jquery-ui-bundle";
import "jquery-ui-bundle/jquery-ui.css";
export default {
  name: "DesignerText",
  props: ["data", "isActive"],
  directives: {
    ClickOutside,
  },
  data() {
    return {
      timeout: null,
    };
  },
  methods: {
    contentChanged() {},
    startEditing() {
      this.$emit("StartEditing", this.data.id);
    },
    stopEditing() {
      this.$emit("StopEditing", this.data.id);
      this.$emit("TextChanged", {
        id: this.data.id,
        text: $("#" + this.data.id).text(),
      });
    },
    setActiveItem() {
      this.$emit("SetActiveElement", this.data.id);
    },
  },
  computed: {
    getStyle() {
      return {
        ...this.data,
        fontSize: this.data.fontSize + "px",
        width: this.data.width + "px",
        height: this.data.height + "px",
        left: this.data.left + "px",
        top: this.data.top + "px",
      };
    },
  },
  mounted() {
    $("#" + this.data.id).draggable({
      smartguides: "._designer-element",
      containment: "#_canvas",
      tolerance: 5,
      scroll: false,
      stop: (element, position) => {
        this.$emit("PositionUpdated", { position, id: this.data.id });
      },
    });

    $("#" + this.data.id).resizable({
      containment: "#_canvas",
      stop: (element, size) => {
        this.$emit("SizeUpdated", { size, id: this.data.id });
      },
    });
  },
  watch: {
    "data.editable": function(val) {
      if (val) {
        $("#" + this.data.id).draggable({ disabled: true });
      } else {
        $("#" + this.data.id).draggable({ disabled: false });
      }
    },
  },
  created() {
    $.ui.plugin.add("draggable", "smartguides", {
      start: function(event, ui) {
        var i = $(this).data("uiDraggable"),
          o = i.options;
        i.elements = [];
        $(
          o.smartguides.constructor != String
            ? o.smartguides.items || ":data(draggable)"
            : o.smartguides
        ).each(function() {
          var $t = $(this);
          var $o = $t.offset();
          if (this != i.element[0])
            i.elements.push({
              item: this,
              width: $t.outerWidth(),
              height: $t.outerHeight(),
              top: $o.top,
              left: $o.left,
            });
        });
      },
      stop: function(event, ui) {
        $(".objectx").css({ display: "none" });
        $(".objecty").css({ display: "none" });
      },
      drag: function(event, ui) {
        var targetWidth = $(ui.helper).width() - 2;
        var targetHeight = $(ui.helper).height() - 2;

        var targetLeft = parseInt(
          $(ui.helper)
            .css("left")
            .replace("px")
        );
        var targetTop = parseInt(
          $(ui.helper)
            .css("top")
            .replace("px")
        );

        var canvasWidth = $("#_canvas").width();
        var canvasHeight = $("#_canvas").height();

        var inst = $(this).data("uiDraggable"),
          o = inst.options;
        var d = o.tolerance;
        $(".objectx").css({ display: "none" });
        $(".objecty").css({ display: "none" });
        var x1 = ui.offset.left,
          x2 = x1 + inst.helperProportions.width,
          y1 = ui.offset.top,
          y2 = y1 + inst.helperProportions.height,
          xc = (x1 + x2) / 2,
          yc = (y1 + y2) / 2;
        for (var i = inst.elements.length - 1; i >= 0; i--) {
          var l = inst.elements[i].left,
            r = l + inst.elements[i].width,
            t = inst.elements[i].top,
            b = t + inst.elements[i].height,
            hc = (l + r) / 2,
            vc = (t + b) / 2;
          var lss = Math.abs(l - x1) <= d;
          var ls = Math.abs(l - x2) <= d;
          var rss = Math.abs(r - x2) <= d;
          var rs = Math.abs(r - x1) <= d;
          var tss = Math.abs(t - y1) <= d;
          var ts = Math.abs(t - y2) <= d;
          var bss = Math.abs(b - y2) <= d;
          var bs = Math.abs(b - y1) <= d;
          var hs = Math.abs(hc - xc) <= d;
          var vs = Math.abs(vc - yc) <= d;
          if (lss) {
            ui.position.left =
              inst._convertPositionTo("relative", { top: 0, left: l }).left -
              inst.margins.left;
            $(".objectx").css({ left: ui.position.left, display: "block" });
          }
          if (rss) {
            ui.position.left =
              inst._convertPositionTo("relative", {
                top: 0,
                left: r - inst.helperProportions.width,
              }).left - inst.margins.left;
            $(".objectx").css({
              left: ui.position.left + ui.helper.width(),
              display: "block",
            });
          }
          if (ls) {
            ui.position.left =
              inst._convertPositionTo("relative", {
                top: 0,
                left: l - inst.helperProportions.width,
              }).left - inst.margins.left;
            $(".objectx").css({
              left: ui.position.left + ui.helper.width(),
              display: "block",
            });
          }
          if (rs) {
            ui.position.left =
              inst._convertPositionTo("relative", { top: 0, left: r }).left -
              inst.margins.left;
            $(".objectx").css({ left: ui.position.left, display: "block" });
          }
          if (tss) {
            ui.position.top =
              inst._convertPositionTo("relative", { top: t, left: 0 }).top -
              inst.margins.top;
            $(".objecty").css({ top: ui.position.top, display: "block" });
          }
          if (ts) {
            ui.position.top =
              inst._convertPositionTo("relative", {
                top: t - inst.helperProportions.height,
                left: 0,
              }).top - inst.margins.top;
            $(".objecty").css({
              top: ui.position.top + ui.helper.height(),
              display: "block",
            });
          }
          if (bss) {
            ui.position.top =
              inst._convertPositionTo("relative", {
                top: b - inst.helperProportions.height,
                left: 0,
              }).top - inst.margins.top;
            $(".objecty").css({
              top: ui.position.top + ui.helper.height(),
              display: "block",
            });
          }
          if (bs) {
            ui.position.top =
              inst._convertPositionTo("relative", { top: b, left: 0 }).top -
              inst.margins.top;
            $(".objecty").css({ top: ui.position.top, display: "block" });
          }
          if (hs) {
            ui.position.left =
              inst._convertPositionTo("relative", {
                top: 0,
                left: hc - inst.helperProportions.width / 2,
              }).left - inst.margins.left;
            $(".objectx").css({
              left: ui.position.left + ui.helper.width() / 2,
              display: "block",
            });
          }
          if (vs) {
            ui.position.top =
              inst._convertPositionTo("relative", {
                top: vc - inst.helperProportions.height / 2,
                left: 0,
              }).top - inst.margins.top;
            $(".objecty").css({
              top: ui.position.top + ui.helper.height() / 2,
              display: "block",
            });
          }
        }
        var right = Math.floor((canvasWidth - targetWidth) / 2);
        var top = Math.floor((canvasHeight - targetHeight) / 2);

        if (Math.abs(targetTop - top) <= d) {
          $(".objecty").css({
            top: canvasHeight / 2,
            display: "block",
            "border-color": "orange",
          });
        }

        if (Math.abs(targetLeft - right) <= d) {
          $(".objectx").css({
            left: canvasWidth / 2,
            display: "block",
            "border-color": "orange",
          });
        }
      },
    });
  },
};
</script>



// WEBPACK FOOTER //
// src/components/DesignerText.vue